const FEATURE_FLAGS = {
  PROPOSALS: "proposals",
};

export default FEATURE_FLAGS;
